import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { CardService } from '../../services/card.service';
import { Card } from 'src/app/_shared/models/card-models/card';
import { AccountDetails } from 'src/app/_shared/models/account-models/account-details';
import { Earnings } from 'src/app/_shared/models/earning-models/earnings';
import { environment } from 'src/environments/environment';
import { catchError, switchMap, takeUntil, tap } from 'rxjs/operators';
import { EMPTY, of, Subject } from 'rxjs';
import { AemService } from '../../../_shared/services/aem-content.service';

@Component({
  selector: 'app-card-banner',
  standalone: false,
  templateUrl: './card-banner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './card-banner.component.scss'
})
export class CardBannerComponent implements OnInit, OnDestroy {
  componentDestroyed = new Subject<void>();
  aemContent: any = '';
  todayDate: string = new Intl.DateTimeFormat('en-US', {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit'
  }).format(new Date());
  cardType: Card;
  customer: AccountDetails;
  image: string;
  cardTitle: string;
  pointTitle: string;
  dateTitle: string;
  isMobile: boolean = false;
  earnings: Earnings;
  logos = ['assets/img/cards/vehicle-car.png'];

  constructor(
    private readonly cardService: CardService,
    private aem: AemService
  ) {}
  ngOnInit(): void {
    this.cardService
      .getCurrentCard()
      .pipe(
        takeUntil(this.componentDestroyed),
        switchMap(card => {
          this.cardType = card;
          return this.cardService.getEarningsWithFallback(card.trackId);
        })
      )
      .subscribe(
        data => {
          if (data && data.earnings) {
            this.earnings = data.earnings;
          }
        },
        error => {}
      );
    this.getAemContent();
    this.checkScreenSize();
  }

  getAemContent() {
    this.aem
      .getCardBannerContent()
      .pipe(
        takeUntil(this.componentDestroyed),
        switchMap((content: any) => {
          if (Object.keys(content).length === 0) {
            return this.aem.fetchContent('card-banner');
          }
          return of(content);
        }),
        tap((content: any) => {
          if (!content) {
            return;
          }
          this.aemContent = content;
          const respObj = JSON.parse(content.pageFields);
          this.cardTitle = respObj.cardTitle;
          this.pointTitle = respObj.pointTitle;
          this.dateTitle = respObj.dateTitle;
          this.image = `${environment.API_URL}/getAemImage?image=${respObj.cardImage}`;
        }),
        catchError(error => {
          this.aemContent = '';
          this.cardTitle = '';
          this.pointTitle = '';
          this.dateTitle = '';
          this.image = '';
          return EMPTY; // Return an empty Observable
        })
      )
      .subscribe();
  }
  ngOnDestroy(): void {
    this.componentDestroyed.next();
    this.componentDestroyed.unsubscribe();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkScreenSize();
  }

  private checkScreenSize() {
    this.isMobile = window.innerWidth < 993;
  }
}
